import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import * as E from "linq";
import { debounceTime } from 'rxjs/operators';

type FilterItem = {
  checked: boolean;
  disabled: boolean;
  caption: string;
};
@Component({
  selector: 'filter-domain-list',
  templateUrl: './filter-domain-list.component.html',
  styleUrls: ['./filter-domain-list.component.scss']
})
export class FilterDomainListComponent implements OnInit {

  @Input() title: string;
  @Input() collapsed: boolean;
  @Output() toggled = new EventEmitter();

  @Input() items: FilterItem[];
  @Output() changed = new EventEmitter<{ items: FilterItem[] }>();

  innerItems: FilterItem[] =[];
  webSitesControl = new FormControl();

  constructor() { }

  ngOnInit(): void {
    this.webSitesControl.setValue(this.items.map(x => x.caption).toString().split(',').join('\n'));
    this.webSitesControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((x) => {
        let arr = x.split("\n").slice(0, 5000); // Ограничиваем до 5000 строк
        this.innerItems = [];
        arr.forEach((obj, index) => {
          this.innerItems.push({ caption: obj, checked: true, disabled: false });
        });

        this.changed.emit({ items: this.innerItems });
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ("items" in changes) {
      const currentValue: FilterItem[] = changes.items.currentValue;
      this.innerItems = E.from(currentValue)
        .select((i) => ({ ...i }))
        .toArray();
    }
  }
}
